module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.f14eee64.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Semibold.otf
// module id = 1484
// module chunks = 40